<div class="wrapper">
  @if (loadingReport) {
    <div class="loading">
      <p-progressSpinner></p-progressSpinner>
    </div>
  }
  @if (!loadingReport) {
    <p-tabs value="0">
      <p-tablist>
        <p-tab value="0">Content</p-tab>
        @if (allowCustomStyling) {
          <p-tab value="1">Styling</p-tab>
        }
      </p-tablist>
      <p-tabpanels>
        <p-tabpanel value="0" header="Content">
          <ng-template #recursiveSection let-sections>
            @for (section of sections; track section) {
              <div class="section">
                <div class="section-box" (mouseenter)="sectionHovered(section, $event)">
                  <div class="section-header" (click)="toggleSection(section.id)">
                    <div class="chevron">
                      <fa-icon [icon]="faChevronRight" [ngClass]="{'expanded': sectionIsExpanded[section.id]}"></fa-icon>
                    </div>
                    @if (editedSectionTitle !== section.id) {
                      <div class="title">
                        <div [innerHTML]="section.title"></div>
                        @if (currentSectionAction.currentSectionId === section.id) {
                          <p-button styleClass="p-button-text" icon="true" pTooltip="Edit section title" (click)="editSectionTitle(section.id, section.title); $event.stopPropagation();">
                            <fa-icon [icon]="faEdit"></fa-icon>
                          </p-button>
                        }
                      </div>
                    }
                    @if (editedSectionTitle === section.id) {
                      <div class="title">
                        <input pInputText [(ngModel)]="editedSectionTitleContent"/>
                        <p-button icon="true" (click)="saveSectionTitle(section.id); $event.stopPropagation();">
                          <fa-icon [icon]="faSave"></fa-icon>
                        </p-button>
                        <p-button styleClass="p-button-text" icon="true" (click)="cancelSaveSectionTitle(); $event.stopPropagation();">
                          <fa-icon [icon]="faTimes"></fa-icon>
                        </p-button>
                      </div>
                    }
                    @if (sectionNumbers[section.id]) {
                      <div class="numbering">{{ sectionNumbers[section.id] }}</div>
                    }
                    <div class="type">
                      <fa-icon [icon]="sectionIconMap[report?.sectionContent[section.id]?.type] || faQuestionCircle"></fa-icon>
                    </div>
                  </div>
                  @if (sectionIsExpanded[section.id] && report?.sectionContent[section.id]; as content) {
                    <div class="section-content">
                      @for (contentItem of (content || []); track contentItem; let idx = $index) {
                        <div class="content-item">
                          @if (content.length > 1 || (contentItem.position && contentItem.position !== 'main')) {
                            <div class="content-position">{{ contentItem.position || 'main' }}</div>
                          }
                          <wm-report-section-content (onContentUpdate)="updateContent(section.id, idx, $event)" [content]="contentItem"></wm-report-section-content>
                        </div>
                      }
                    </div>
                  }
                </div>
                @if ((section.subsections || []).length > 0 && sectionIsExpanded[section.id]) {
                  <div class="subsections">
                    <ng-container *ngTemplateOutlet="recursiveSection; context:{ $implicit: section.subsections }"></ng-container>
                  </div>
                }
              </div>
            }
          </ng-template>
          <div class="sections" #sectionsContainer (mouseleave)="hideSectionActions()">
            <ng-container *ngTemplateOutlet="recursiveSection; context:{ $implicit: report?.sections }"></ng-container>
            <div class="section-actions-wrapper" [ngStyle]="{'right.px': currentSectionAction.right, 'top.px': currentSectionAction.top, 'display': !disableSectionActions && currentSectionAction.visible ? 'flex' : 'none'}">
              <div class="section-actions">
                @if (!currentSectionAction.isFirst) {
                  <div class="section-action" pTooltip="Add section before" showDelay="1000" tooltipPosition="left" (click)="insertSectionBefore(currentSectionAction.currentSectionId)">
                    <fa-icon [icon]="plusUp"></fa-icon>
                  </div>
                }
                @if (currentSectionAction.isFirst) {
                  <div class="empty-action"></div>
                }
              </div>
              <div class="section-actions">
                <div class="section-action" pTooltip="Move one level higher" showDelay="1000" tooltipPosition="left" (click)="moveSectionHigher(currentSectionAction.currentSectionId)">
                  <fa-icon [icon]="faArrowLeft"></fa-icon>
                </div>
                <div class="section-action" pTooltip="Move section up" showDelay="1000" tooltipPosition="left" (click)="moveSectionUp(currentSectionAction.currentSectionId)">
                  <fa-icon [icon]="faArrowUp"></fa-icon>
                </div>
                <div class="section-action" pTooltip="Move section down" showDelay="1000" tooltipPosition="left" (click)="moveSectionDown(currentSectionAction.currentSectionId)">
                  <fa-icon [icon]="faArrowDown"></fa-icon>
                </div>
                <div class="section-action delete" pTooltip="Delete section" showDelay="1000" tooltipPosition="left" (click)="deleteSection(currentSectionAction.currentSectionId)">
                  <fa-icon [icon]="faTrash"></fa-icon>
                </div>
              </div>
              <div class="section-actions">
                @if (!currentSectionAction.isLast) {
                  <div class="section-action" pTooltip="Add section after" showDelay="1000" tooltipPosition="left" (click)="insertSectionAfter(currentSectionAction.currentSectionId)">
                    <fa-icon [icon]="$any(plusDown)"></fa-icon>
                  </div>
                }
                <div class="section-action" pTooltip="Add sub-section" showDelay="1000" tooltipPosition="left" (click)="addSubSection(currentSectionAction.currentSectionId)">
                  <fa-icon [icon]="$any(plusRightDown)"></fa-icon>
                </div>
              </div>
            </div>
          </div>
        </p-tabpanel>
        <p-tabpanel value="1">
          <wm-editable-text [supportedEditModes]="['css']" [ngModel]="report?.renderConfig.renderingProfiles['default']?.styling?.cssText" (ngModelChange)="saveStyling($event)"></wm-editable-text>
        </p-tabpanel>
      </p-tabpanels>
    </p-tabs>
    <div class="custom-button" (click)="showPreview()">
      <div class="icon">
        <fa-icon [icon]="faEye"></fa-icon>
      </div>
      <div class="label">Show Preview</div>
    </div>
  }
</div>
